// @generated by protobuf-ts 2.8.1 with parameter generate_dependencies,long_type_number,ts_nocheck,optimize_code_size
// @generated from protobuf file "c1/api/assets/v1/app_icons.proto" (package "c1.api.assets.v1", syntax proto3)
// tslint:disable
// @ts-nocheck
import { ServiceType } from "@protobuf-ts/runtime-rpc";
import { MessageType } from "@protobuf-ts/runtime";
import { SrcSet } from "./images";
/**
 * @generated from protobuf message c1.api.assets.v1.AppIcon
 */
export interface AppIcon {
    /**
     * @generated from protobuf field: c1.api.assets.v1.AppIconRef app_icon = 1;
     */
    appIcon?: AppIconRef;
    /**
     * @generated from protobuf field: string src = 2;
     */
    src: string;
    /**
     * @generated from protobuf field: c1.api.assets.v1.SrcSet src_set = 3;
     */
    srcSet?: SrcSet;
}
/**
 * @generated from protobuf message c1.api.assets.v1.AppIconRef
 */
export interface AppIconRef {
    /**
     * @generated from protobuf field: string app_id = 1;
     */
    appId: string;
}
/**
 * @generated from protobuf message c1.api.assets.v1.GetAppIconRequest
 */
export interface GetAppIconRequest {
    /**
     * @generated from protobuf field: c1.api.assets.v1.AppIconRef app_icon_ref = 1;
     */
    appIconRef?: AppIconRef;
}
/**
 * @generated from protobuf message c1.api.assets.v1.GetAppIconResponse
 */
export interface GetAppIconResponse {
    /**
     * @generated from protobuf field: c1.api.assets.v1.AppIcon app_icon = 1;
     */
    appIcon?: AppIcon;
}
/**
 * @generated from protobuf message c1.api.assets.v1.BulkGetAppIconsRequest
 */
export interface BulkGetAppIconsRequest {
    /**
     * @generated from protobuf field: repeated c1.api.assets.v1.AppIconRef app_icons = 1;
     */
    appIcons: AppIconRef[];
}
/**
 * @generated from protobuf message c1.api.assets.v1.BulkGetAppIconsResponse
 */
export interface BulkGetAppIconsResponse {
    /**
     * @generated from protobuf field: repeated c1.api.assets.v1.AppIcon list = 1;
     */
    list: AppIcon[];
}
// @generated message type with reflection information, may provide speed optimized methods
class AppIcon$Type extends MessageType<AppIcon> {
    constructor() {
        super("c1.api.assets.v1.AppIcon", [
            { no: 1, name: "app_icon", kind: "message", T: () => AppIconRef },
            { no: 2, name: "src", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 3, name: "src_set", kind: "message", T: () => SrcSet }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.assets.v1.AppIcon
 */
export const AppIcon = new AppIcon$Type();
// @generated message type with reflection information, may provide speed optimized methods
class AppIconRef$Type extends MessageType<AppIconRef> {
    constructor() {
        super("c1.api.assets.v1.AppIconRef", [
            { no: 1, name: "app_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { pattern: "^[a-zA-Z0-9]{27}$" } } } }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.assets.v1.AppIconRef
 */
export const AppIconRef = new AppIconRef$Type();
// @generated message type with reflection information, may provide speed optimized methods
class GetAppIconRequest$Type extends MessageType<GetAppIconRequest> {
    constructor() {
        super("c1.api.assets.v1.GetAppIconRequest", [
            { no: 1, name: "app_icon_ref", kind: "message", T: () => AppIconRef }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.assets.v1.GetAppIconRequest
 */
export const GetAppIconRequest = new GetAppIconRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class GetAppIconResponse$Type extends MessageType<GetAppIconResponse> {
    constructor() {
        super("c1.api.assets.v1.GetAppIconResponse", [
            { no: 1, name: "app_icon", kind: "message", T: () => AppIcon }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.assets.v1.GetAppIconResponse
 */
export const GetAppIconResponse = new GetAppIconResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class BulkGetAppIconsRequest$Type extends MessageType<BulkGetAppIconsRequest> {
    constructor() {
        super("c1.api.assets.v1.BulkGetAppIconsRequest", [
            { no: 1, name: "app_icons", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => AppIconRef, options: { "validate.rules": { repeated: { minItems: "1", maxItems: "100" } } } }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.assets.v1.BulkGetAppIconsRequest
 */
export const BulkGetAppIconsRequest = new BulkGetAppIconsRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class BulkGetAppIconsResponse$Type extends MessageType<BulkGetAppIconsResponse> {
    constructor() {
        super("c1.api.assets.v1.BulkGetAppIconsResponse", [
            { no: 1, name: "list", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => AppIcon }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.assets.v1.BulkGetAppIconsResponse
 */
export const BulkGetAppIconsResponse = new BulkGetAppIconsResponse$Type();
/**
 * @generated ServiceType for protobuf service c1.api.assets.v1.AppIconService
 */
export const AppIconService = new ServiceType("c1.api.assets.v1.AppIconService", [
    { name: "GetAppIcon", options: { "authz.method": { role: "VIEWER" } }, I: GetAppIconRequest, O: GetAppIconResponse },
    { name: "BulkGetAppIcons", options: { "authz.method": { role: "VIEWER" } }, I: BulkGetAppIconsRequest, O: BulkGetAppIconsResponse }
]);
